import axios from '../utils/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client/`;

const buildRecallQuery = ({
    sortBy,
    sortOrder,
    searchField,
    searchTerm,
    statusFilter,
    dateFrom,
    dateTo,
}) => {
    const parts = [];

    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }

    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }

    if (searchTerm?.trim()) {
        const field = searchField || 'title';
        parts.push(`${field}==*${searchTerm.trim()}*`);
    }

    if (statusFilter && statusFilter !== 'ALL') {
        parts.push(`status==${statusFilter}`);
    }

    if (dateFrom) {
        parts.push(`createdAt=ged=${dateFrom}`);
    }

    if (dateTo) {
        parts.push(`createdAt=led=${dateTo}`);
    }

    return parts.join(',');
};

const getRecallRequests = (clinicId, pageNo = 0, pageSize = 20, queryOptions = {}) => {
    const q = buildRecallQuery(queryOptions);

    return axios.get(`${API_URL}clinics/${clinicId}/recalls`, {
        params: {
            pageNo,
            pageSize,
            ...(q ? { q } : {}),
        },
    });
};

const getRecallRequestById = (clinicId, reqId) =>
    axios.get(`${API_URL}clinics/${clinicId}/recalls/${reqId}`);

const createRecallRequest = (clinicId, data) =>
    axios.post(`${API_URL}clinics/${clinicId}/recalls`, {
        title: data.title,
        notes: data.notes,
    });

const uploadRecallFiles = (clinicId, recallId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${API_URL}clinics/${clinicId}/recalls/${recallId}/upload-files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

const downloadInitialRecallReport = (clinicId, reqId) =>
    axios.get(`${API_URL}clinics/${clinicId}/recalls/${reqId}/initial-report`, {
        responseType: 'blob',
    });

const recallService = {
    getRecallRequests,
    getRecallRequestById,
    createRecallRequest,
    uploadRecallFiles,
    downloadInitialRecallReport,
    buildRecallQuery,
};

export default recallService;
